export default {"src":"/hedera/_next/static/media/near_light.52f5ca81.svg","height":10,"width":10};